import { FormProvider, useForm } from 'react-hook-form';

import { EmailForm, type EmailFormData } from './EmailForm';

export interface EmailFormWrapperProps {
  onSubmit: (data: EmailFormData) => void;
  onCancel: () => void;
  isLoading: boolean;
  /** The sender, read-only, and the subject and message to start from. */
  formData: EmailFormData;
}

export const EmailFormWrapper = ({
  onSubmit,
  onCancel,
  isLoading,
  formData,
}: EmailFormWrapperProps) => {
  const methods = useForm<EmailFormData>({
    defaultValues: formData,
  });

  return (
    <FormProvider {...methods}>
      <EmailForm
        onSubmit={onSubmit}
        onCancel={onCancel}
        isLoading={isLoading}
      />
    </FormProvider>
  );
};
